// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactUsV2_container__UcFJ6","content":"ContactUsV2_content__2cj-x","text":"ContactUsV2_text__1cCR9","contact":"ContactUsV2_contact__3MTFL"};